module.exports = __webpack_public_path__ + "static/img/find.34939af.34939af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/find.34939af.jpg
// module id = TFOy
// module chunks = 3